import React, { useState } from "react";
import "./CreateFirstKnowlegde.scss";
import Newknowledge from "../knowledgeComponents/Newknowlegde/Newknowledge";

const CreateFirstKnowlegde = () => {
  const [activeTab, setActivetab] = useState("");

  const handleActiveTab = (tab) => {
    setActivetab(tab);
  };

  return (
    <div>
      {activeTab === "newKnowledge" ? (
        <Newknowledge />
      ) : (
        <div className="knowledgeBasis-centered-container">
          <h5>Create Your First Knowledge Base</h5>
          <p>
            Create a knowledge base to give your agents important context andinformation about your company. Once your agent is connected to aknowledge base, it will have the
            ability to handle literally thousands of FAQs,overcome any objection and more... with perfect recall and infinite memory.
          </p>
            <button className="themebtn-1" onClick={() => handleActiveTab("newKnowledge")}>
              Create Knowledge Base
            </button>
        </div>
      )}
    </div>
  );
};

export default CreateFirstKnowlegde;
